import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getRefunds(page, perPage) {
        return Axios.get(`${baseURL}billing/refunds`, {
            params: { page, perPage }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    saveRefund(refundId, params) {
        return Axios.put(`${baseURL}billing/refund/${refundId}`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    convertToCredit(refundId, params) {
        return Axios.post(
            `${baseURL}billing/convert-credit/${refundId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
